import handleApiError from '@/shared/api/handleApiError';
import {
  getOperationsDictionary,
  getOperationsForBonus,
} from '@/shared/lib/welcomeBonus/api';
import {
  cancelWelcomeBonusOperationXmlId,
  learnOrderXmlId,
  learnPaymentXmlId,
  welcomeBonusOperationXmlId,
} from '@/shared/lib/welcomeBonus/constants';
import { ref } from 'vue';

export const lastBonusOperation = ref(null);

export async function needToShowWelcomeModal(email: string): Promise<boolean> {
  try {
    const { data: dictionary } = await getOperationsDictionary();
    const operationTypes = dictionary?.response?.LoyaltyOperationsInfo as any[];

    if (!operationTypes || !operationTypes.length) {
      return false;
    }

    const welcomeOperation = operationTypes.find(
      (item: any) => item.xmlId === welcomeBonusOperationXmlId,
    );
    const cancelWelcomeOperation = operationTypes.find(
      (item: any) => item.xmlId === cancelWelcomeBonusOperationXmlId,
    );
    const learnPaymentOperation = operationTypes.find(
      (item: any) => item.xmlId === learnPaymentXmlId,
    );
    const learnOrderOperation = operationTypes.find(
      (item: any) => item.xmlId === learnOrderXmlId,
    );

    if (
      !welcomeOperation ||
        !cancelWelcomeOperation ||
        !learnPaymentOperation ||
        !learnOrderOperation
    ) {
      return false;
    }

    const { data } = await getOperationsForBonus(email, [
      ...welcomeOperation.ids,
      ...cancelWelcomeOperation.ids,
      ...learnPaymentOperation.ids,
      ...learnOrderOperation.ids,
    ]);
    const operations = data?.response?.operations ?? [];

    if (!operations.length) {
      return false;
    }

    if (operations.some((item: any) => cancelWelcomeOperation.ids.includes(item.operationId))) {
      return false;
    }

    if (operations.some((item: any) => learnPaymentOperation.ids.includes(item.operationId))) {
      return false;
    }

    if (operations.some((item: any) => learnOrderOperation.ids.includes(item.operationId))) {
      return false;
    }

    lastBonusOperation.value = operations.find(
      (item: any) => welcomeOperation.ids.includes(item.operationId),
    );
    if (lastBonusOperation.value) {
      return true;
    }
  } catch (error) {
    handleApiError(error);
  }

  return false;
}

export async function needToShowWelcomeSmsModal(phone: string) {
  return false;
}
